// project
import * as RS from "@/components.run/run-study";


export const StartStudy = {
	name: "Run.StartStudy",
	path: "/p/s/:proxyId",
	component: RS.RunStudy,
	meta: {
		title: "Study",
		public: true,
		navHidden:true
	}
}